import { PermissionEnum } from "TypesAndInterfaces";
import { AdyenRoutesName } from "./route-names";

export interface AdyenRouteConfig {
  path: string;
  searchParameters?: string[];
  permission?: PermissionEnum;
}

export const AdyenRoutes: Record<AdyenRoutesName, AdyenRouteConfig> = {
  LOGIN_WITH_MIRAKL: {
    path: "/login/auth/mirakl",
  },
  DASHBOARD: {
    path: "/dashboard",
    },
  LOGIN: {
    path: "/login",
  },
  FORGOT_PASSWORD: {
    path: "/login/forgot-password",
  },
  RESET_PASSWORD: {
    path: "/reset-password/:uuid",
  },
  DASHBOARD_MARKETPLACES: {
    path: "/marketplaces",
  },
  DASHBOARD_REPORTS: {
    path: "/reports",
    permission: PermissionEnum.VIEW_REPORTS,
  },
  DASHBOARD_USERS: {
    path: "/users",
  },
  DASHBOARD_LOGS: {
    path: "/logs",
    permission: PermissionEnum.VIEW_LOGS,
  },
  DASHBOARD_FIRST_MARKETPLACE: {
    path: "/marketplaces/create-marketplace",
    permission: PermissionEnum.MANAGE_SHOPS,
  },
  EDIT_MARKETPLACE: {
    path: "/marketplaces/edit-marketplace",
    permission: PermissionEnum.MANAGE_SHOPS,
  },
  HOP_AUTH: {
    path: "/hop/auth/mirakl",
  },
  HOP: {
    path: "/hop/:marketplaceId/:shopId",
  },
  MARKETPLACE_LOGS: {
    path: "/logs/marketplace-logs",
    searchParameters: ["marketplaceId"],
    permission: PermissionEnum.VIEW_LOGS,
  },
  BOARDING_TUTORIAL: {
    path: "/boarding-tutorial",
  },
  MARKETPLACE_CONTROL: {
    path: "/marketplace-control",
  },
};
